import { useMutation } from "@apollo/client";
import { useCallback } from "react";

import { GqlProjectUpdateInput } from "~/__generated__";

import { ME_GET_PROJECT_INFO } from "../../../api/useMeGetProjectInfoQuery";
import { ProjectUpdateDocument } from "../mutations.generated";

export default function useProjectUpdate(projectId: string) {
    const [updateProject, { data, loading, error }] = useMutation(ProjectUpdateDocument, {
        refetchQueries: [ME_GET_PROJECT_INFO],
    });

    return {
        updateProject: useCallback(
            (data: Omit<GqlProjectUpdateInput, "projectId">) =>
                updateProject({
                    variables: {
                        input: { ...data, projectId },
                    },
                }),
            [updateProject, projectId],
        ),
        data,
        loading,
        error,
    };
}
